"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1410],{

/***/ 60316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aG": function() { return /* reexport */ StructuredData_Breadcrumb; },
  "By": function() { return /* reexport */ StructuredData_Faq; },
  "TR": function() { return /* reexport */ StructuredData_Logo; },
  "dc": function() { return /* reexport */ StructuredData_NltOffer; },
  "_6": function() { return /* reexport */ StructuredData_OfferList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/containers/data/brands.json
var brands = __webpack_require__(11669);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/NltOffer.tsx





var NltOffer = function NltOffer(_ref) {
  var offerData = _ref.offerData;
  var data = {
    "@context": "https://schema.org/",
    "@type": "Vehicle",
    "name": "".concat(offerData.vehicle.name, " - Noleggio a Lungo Termine"),
    "image": offerData.images.map(function (image) {
      return image.src;
    }),
    "description": "".concat(offerData.vehicle.name, " a ").concat(offerData.monthlyRate, "\u20AC al mese! Con CarPlanner hai manutenzione, assicurazione, bollo, tassa di propriet\xE0 a molti altri servizi, inclusi in un unico canone mensile."),
    "sku": offerData.code,
    "mpn": offerData.id,
    "fuelType": offerData.vehicle.engine.fuel,
    "brand": {
      "@type": "Brand",
      "name": offerData.vehicle.brand,
      "logo": brands.find(function (brand) {
        return brand.href === offerData.vehicle.brandCode;
      }).image
    },
    "offers": {
      "@type": "Offer",
      "url": "https://www.carplanner.com/noleggio-a-lungo-termine/".concat(offerData.vehicle.brandCode, "/").concat(offerData.vehicle.modelCode, "/").concat(offerData.code),
      "priceCurrency": 'EUR',
      "price": offerData.monthlyRate,
      "itemCondition": 'https://schema.org/NewCondition',
      "availability": 'https://schema.org/LimitedAvailability',
      "seller": {
        '@type': 'Organization',
        "name": "CarPlanner",
        "url": "https://www.carplanner.com/",
        "logo": "https://static1.carplanner.com/logos/carplanner.svg"
      }
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataNltOffer",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_NltOffer = (NltOffer);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Logo.tsx




var Logo = function Logo() {
  var data = {
    "@context": "https://schema.org/",
    "@type": "Organization",
    "name": "Noleggio a Lungo Termine",
    "url": "https://www.carplanner.com/",
    "logo": "https://static1.carplanner.com/logos/carplanner.svg"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataLogo",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Logo = (Logo);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./server/api/nlt.ts
var nlt = __webpack_require__(27449);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Faq.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Faq = function Faq() {
  var _useState = (0,react.useState)([]),
      faqSingleItems = _useState[0],
      setFaqSingleItems = _useState[1];

  (0,react.useEffect)(function () {
    function getFaqs() {
      return _getFaqs.apply(this, arguments);
    }

    function _getFaqs() {
      _getFaqs = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var faqs;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,nlt/* getFaqAutoCompleteItems */.eF)();

              case 2:
                faqs = _context.sent;
                setFaqSingleItems(faqs.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getFaqs.apply(this, arguments);
    }

    if (!faqSingleItems.length) {
      getFaqs();
    }
  });
  var faqItems = {};
  faqSingleItems.forEach(function (faqItem) {
    faqItems[faqItem.uri] = faqItems[faqItem.uri] || [];
    faqItems[faqItem.uri].push(_objectSpread({}, faqItem));
  });
  var data = {
    "@context": "https://schema.org/",
    "@type": "FAQPage",
    "mainEntity": Object.keys(faqItems).map(function (faqUri) {
      return {
        "@type": "Question",
        "url": "https://www.carplanner.com/noleggio-a-lungo-termine/faq/".concat(faqUri),
        "name": faqItems[faqUri][0].title,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faqItems[faqUri].map(function (faqItem) {
            return "<p><strong>".concat(faqItem.q || '', "</strong> ").concat(faqItem.a || '', "</p>");
          }).join('')
        }
      };
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataFaq",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Faq = (Faq);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Breadcrumb.tsx




var Breadcrumb = function Breadcrumb(_ref) {
  var breadcrumbData = _ref.breadcrumbData;
  var data = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbData.map(function (crumbItem, idx) {
      return {
        "@type": "ListItem",
        "position": idx + 1,
        "name": crumbItem.title,
        "item": "https://carplanner.com".concat(crumbItem.href)
      };
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataBreadcrumb",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Breadcrumb = (Breadcrumb);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/OfferList.tsx




var OfferList = function OfferList(_ref) {
  var items = _ref.items;
  var data = {
    "@context": "https://schema.org/",
    "@type": "ItemList",
    "numberOfItems": items.length,
    "itemListElement": items.map(function (item, idx) {
      return {
        "@type": "ListItem",
        "position": idx,
        "url": item
      };
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataOfferList",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_OfferList = (OfferList);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/index.ts






/***/ }),

/***/ 11410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14416);
/* harmony import */ var src_components_common_GoogleTagManager___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40933);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48641);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18132);
/* harmony import */ var src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60316);
/* harmony import */ var src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4524);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);











var Pagination = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6319), __webpack_require__.e(804), __webpack_require__.e(1937), __webpack_require__.e(1483)]).then(__webpack_require__.bind(__webpack_require__, 81483));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(81483)];
    }
  }
});
var HomeOffersList = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6741), __webpack_require__.e(5061), __webpack_require__.e(7651), __webpack_require__.e(7855), __webpack_require__.e(7120), __webpack_require__.e(2668), __webpack_require__.e(2518)]).then(__webpack_require__.bind(__webpack_require__, 52711));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(52711)];
    }
  }
});
var Offer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6741), __webpack_require__.e(7855), __webpack_require__.e(7120), __webpack_require__.e(9805)]).then(__webpack_require__.bind(__webpack_require__, 59805));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(59805)];
    }
  }
});
var AutoPromo = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6741), __webpack_require__.e(7855), __webpack_require__.e(7120), __webpack_require__.e(5156)]).then(__webpack_require__.bind(__webpack_require__, 35156));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(35156)];
    }
  }
});
var SuggestedFilters = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6741), __webpack_require__.e(7651), __webpack_require__.e(7855), __webpack_require__.e(7120), __webpack_require__.e(2668)]).then(__webpack_require__.bind(__webpack_require__, 83291));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(83291)];
    }
  }
});

var NltOffersContainer = function NltOffersContainer(_ref) {
  var filterMenuIsOpen = _ref.filterMenuIsOpen,
      offers = _ref.offers,
      otherOffers = _ref.otherOffers,
      bgColor = _ref.bgColor;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
  var offerItems = offers.items;

  var onPaginatorClickHandler = function onPaginatorClickHandler(page) {
    return dispatch((0,src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_5__/* .setListingPage */ .Dx)(page));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Grid */ .rj, {
      templateColumns: {
        md: "repeat(".concat(filterMenuIsOpen ? 2 : 3, ", 1fr)"),
        lg: "repeat(".concat(filterMenuIsOpen ? 3 : 4, ", 1fr)")
      },
      gap: 6,
      pr: "l",
      pt: "l",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_components_common_GoogleTagManager___WEBPACK_IMPORTED_MODULE_3__/* .GtmList */ .cC, {
        items: offerItems.filter(function (offer) {
          return offer.code !== 'auto-promo';
        }).map(function (offer) {
          return {
            name: offer.model,
            id: offer.code,
            monthlyRate: offer.monthlyRate,
            brand: offer.brand,
            category: offer.category,
            variant: offer.version
          };
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(SuggestedFilters, {
        colSpan: {
          md: filterMenuIsOpen ? 2 : 3,
          lg: filterMenuIsOpen ? 3 : 4
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_4__/* .OfferList */ ._6, {
        items: offerItems.map(function (item) {
          return ['https://carplanner.com/noleggio-a-lungo-termine/', item.brandCode, '/', item.modelCode, '/', item.code, '?deposit=', item.deposit, '&contractLength=', item.contractLength, '&annualMileage=', item.annualMileage].join('');
        })
      }), offerItems.map(function (item) {
        return item.code === 'auto-promo' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .GridItem */ .P4, {
          display: "inline-grid",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(AutoPromo, {
            item: item
          })
        }, "".concat(item.code, "- ").concat(item.title, " ")) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .GridItem */ .P4, {
          display: "inline-grid",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Offer, {
            item: item
          })
        }, item.code);
      }), offerItems.length ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .GridItem */ .P4, {
        colSpan: {
          md: filterMenuIsOpen ? 2 : 3,
          lg: filterMenuIsOpen ? 3 : 4
        },
        mt: "-2",
        textAlign: "left",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Pagination, {
          currentPage: offers.currentPage,
          perPage: offers.pageSize,
          total: offers.results,
          onClick: onPaginatorClickHandler
        })
      }, "load-more") : null]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
      display: offerItems.length ? 'none' : 'block',
      float: "right",
      pl: {
        base: 'l',
        md: 'm'
      },
      pr: "l",
      w: {
        base: '100%',
        md: '75%'
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Heading */ .X6, {
        py: "l",
        as: "h3",
        fontSize: "2xl",
        fontFamily: "Montserrat-SemiBold",
        children: t('nltPage:notFound')
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(HomeOffersList, {
        action: t('indexPage:nlt_offers.action'),
        alt: t('indexPage:nlt_offers.alt'),
        bgColor: bgColor || 'baseNeutral.100',
        href: "/noleggio-a-lungo-termine",
        offers: otherOffers,
        numPerView: filterMenuIsOpen ? 3 : 4,
        pt: "0"
      })]
    })]
  });
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    filterMenuIsOpen: state.nlt.filterMenuIsOpen,
    otherOffers: state.nlt.offers,
    offers: state.nlt.filteredOffers,
    ownProps: ownProps
  };
};

/* harmony default export */ __webpack_exports__["default"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(mapStateToProps)(NltOffersContainer));

/***/ }),

/***/ 11669:
/***/ (function(module) {

module.exports = JSON.parse('[{"href":"alfa-romeo","image":"https://static1.carplanner.com/cars/brands/alfa-romeo.svg","name":"Alfa Romeo","slug":"ALF"},{"href":"abarth","image":"https://static1.carplanner.com/cars/brands/abarth.svg","name":"Abarth","slug":"ABA"},{"href":"aston-martin","image":"https://static1.carplanner.com/cars/brands/aston-martin.svg","name":"Aston Martin","slug":"AST"},{"href":"audi","image":"https://static1.carplanner.com/cars/brands/audi.svg","name":"Audi","slug":"AUD"},{"href":"bentley","image":"https://static1.carplanner.com/cars/brands/bentley.svg","name":"Bentley","slug":"BEN"},{"href":"bmw","image":"https://static1.carplanner.com/cars/brands/bmw.svg","name":"BMW","slug":"BMW"},{"href":"cadillac","image":"https://static1.carplanner.com/cars/brands/cadillac.svg","name":"Cadillac","slug":"CAD"},{"href":"chevrolet","image":"https://static1.carplanner.com/cars/brands/chevrolet.svg","name":"Chevrolet","slug":"CHC"},{"href":"chrysler","image":"https://static1.carplanner.com/cars/brands/chrysler.svg","name":"Chrysler","slug":"CHR"},{"href":"citroen","image":"https://static1.carplanner.com/cars/brands/citroen.svg","name":"Citroen","slug":"CIT"},{"href":"cupra","image":"https://static1.carplanner.com/cars/brands/cupra.svg","name":"Cupra","slug":"CUP"},{"href":"dacia","image":"https://static1.carplanner.com/cars/brands/dacia.svg","name":"Dacia","slug":"DAC"},{"href":"dr","image":"https://static1.carplanner.com/cars/brands/dr.svg","name":"DR","slug":"DRM"},{"href":"ds","image":"https://static1.carplanner.com/cars/brands/ds.svg","name":"DS","slug":"DSA"},{"href":"ferrari","image":"https://static1.carplanner.com/cars/brands/ferrari.svg","name":"Ferrari","slug":"FER"},{"href":"fiat","image":"https://static1.carplanner.com/cars/brands/fiat.svg","name":"Fiat","slug":"FIA"},{"href":"ford","image":"https://static1.carplanner.com/cars/brands/ford.svg","name":"Ford","slug":"FOR"},{"href":"honda","image":"https://static1.carplanner.com/cars/brands/honda.svg","name":"Honda","slug":"HON"},{"href":"hyundai","image":"https://static1.carplanner.com/cars/brands/hyundai.svg","name":"Hyundai","slug":"HYU"},{"href":"infiniti","image":"https://static1.carplanner.com/cars/brands/infiniti.svg","name":"Infiniti","slug":"INF"},{"href":"jaguar","image":"https://static1.carplanner.com/cars/brands/jaguar.svg","name":"Jaguar","slug":"JAG"},{"href":"jeep","image":"https://static1.carplanner.com/cars/brands/jeep.svg","name":"Jeep","slug":"JEE"},{"href":"kia","image":"https://static1.carplanner.com/cars/brands/kia.svg","name":"Kia","slug":"KIA"},{"href":"lamborghini","image":"https://static1.carplanner.com/cars/brands/lamborghini.svg","name":"Lamborghini","slug":"LAM"},{"href":"lancia","image":"https://static1.carplanner.com/cars/brands/lancia.svg","name":"Lancia","slug":"LAN"},{"href":"land-rover","image":"https://static1.carplanner.com/cars/brands/land-rover.svg","name":"Land Rover","slug":"LND"},{"href":"lexus","image":"https://static1.carplanner.com/cars/brands/lexus.svg","name":"Lexus","slug":"LEX"},{"href":"lotus","image":"https://static1.carplanner.com/cars/brands/lotus.svg","name":"Lotus","slug":"LOT"},{"href":"mahindra","image":"https://static1.carplanner.com/cars/brands/mahindra.svg","name":"Mahindra","slug":"MAH"},{"href":"maserati","image":"https://static1.carplanner.com/cars/brands/maserati.svg","name":"Maserati","slug":"MAS"},{"href":"mazda","image":"https://static1.carplanner.com/cars/brands/mazda.svg","name":"Mazda","slug":"MAZ"},{"href":"mclaren","image":"https://static1.carplanner.com/cars/brands/mclaren.svg","name":"McLaren","slug":"MCL"},{"href":"mercedes","image":"https://static1.carplanner.com/cars/brands/mercedes.svg","name":"Mercedes-Benz","slug":"MER"},{"href":"mg","image":"https://static1.carplanner.com/cars/brands/mg.svg","name":"MG","slug":"MGG"},{"href":"mini","image":"https://static1.carplanner.com/cars/brands/mini.svg","name":"Mini","slug":"MIN"},{"href":"mitsubishi","image":"https://static1.carplanner.com/cars/brands/mitsubishi.svg","name":"Mitsubishi","slug":"MIT"},{"href":"nissan","image":"https://static1.carplanner.com/cars/brands/nissan.svg","name":"Nissan","slug":"NIS"},{"href":"opel","image":"https://static1.carplanner.com/cars/brands/opel.svg","name":"Opel","slug":"OPE"},{"href":"peugeot","image":"https://static1.carplanner.com/cars/brands/peugeot.svg","name":"Peugeot","slug":"PEU"},{"href":"porsche","image":"https://static1.carplanner.com/cars/brands/porsche.svg","name":"Porsche","slug":"POR"},{"href":"renault","image":"https://static1.carplanner.com/cars/brands/renault.svg","name":"Renault","slug":"REN"},{"href":"rolls-royce","image":"https://static1.carplanner.com/cars/brands/rolls-royce.svg","name":"Rolls-Royce","slug":"ROL"},{"href":"seat","image":"https://static1.carplanner.com/cars/brands/seat.svg","name":"Seat","slug":"SEA"},{"href":"skoda","image":"https://static1.carplanner.com/cars/brands/skoda.svg","name":"Skoda","slug":"SKO"},{"href":"smart","image":"https://static1.carplanner.com/cars/brands/smart.svg","name":"Smart","slug":"SMA"},{"href":"ssangyong","image":"https://static1.carplanner.com/cars/brands/ssangyong.svg","name":"Ssangyong","slug":"SAN"},{"href":"subaru","image":"https://static1.carplanner.com/cars/brands/subaru.svg","name":"Subaru","slug":"SUB"},{"href":"suzuki","image":"https://static1.carplanner.com/cars/brands/suzuki.svg","name":"Suzuki","slug":"SUZ"},{"href":"tesla","image":"https://static1.carplanner.com/cars/brands/tesla.svg","name":"Tesla","slug":"TES"},{"href":"toyota","image":"https://static1.carplanner.com/cars/brands/toyota.svg","name":"Toyota","slug":"TOY"},{"href":"volkswagen","image":"https://static1.carplanner.com/cars/brands/volkswagen.svg","name":"Volkswagen","slug":"VLK"},{"href":"volvo","image":"https://static1.carplanner.com/cars/brands/volvo.svg","name":"Volvo","slug":"VOL"}]');

/***/ })

}]);